import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import history from './browserHistory'
import './scss/App.scss';
import LandingPage from './components/LandingPage/LandingPage'
import Overview from './components/Overview/Overview'

function App(props) {

  return (
    <Router basename='/more-impact' history={history}>
      <div className="react-app">
        <Switch>
          <Route exact path='/' component={LandingPage}>
            <LandingPage />
          </Route>
          <Route path='/overview' component={Overview}>
            <Overview />
          </Route>
          </Switch>
      </div>
    </Router>
  );
}

export default App;